import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Card from "../../components/JobCard";
import { useNavigate, useLocation } from "react-router-dom";
import CircularLoader from "../../components/loader";
import HomeHeader from "../../components/HomeHeader";
import axios from "axios"; // For making HTTP requests

function CreatedJobs() {
  const navigate = useNavigate();
  const location = useLocation();
  const [inProgressJobs, setInProgressJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const headerTitle = location?.state;

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  useEffect(() => {
    if (token) {
      const fetchJobs = async () => {
        try {
          const response = await axios.get(" https://jobmanagement-497524552274.us-central1.run.app/api/jobs/list", {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          // Filter only jobs with IN-PROGRESS status
          const inProgressList = response.data.filter((job) => job.status === "CREATED");

          setInProgressJobs(inProgressList);
        } catch (err) {
          setError("Failed to fetch jobs. Please try again.");
        } finally {
          setLoading(false);
        }
      };

      fetchJobs();
    }
  }, [token]);

  const handleViewDetails = (jobId) => {
    navigate(`/job-details/${jobId}`);
  };

  return (
    <>
      {loading && <CircularLoader position="loaderMiddle" />}
      {error && <div>{error}</div>}
      <Grid margin="5%" bgcolor="#FFFFFF">
        <Grid pb={1} display="flex" alignItems="center">
          <HomeHeader header={headerTitle || "In Progress Jobs"} />
        </Grid>

        {inProgressJobs.length > 0 ? (
          <Grid>
            <h3>CREATED JOBS</h3>
            {inProgressJobs.map((job, i) => (
              <div key={i}>
                <div>Job ID: {job.id}</div>
                <Card
                  key={i}
                  headerTitle={headerTitle}
                  showTitle={true}
                  profile={false}
                  data={job}
                  onViewDetails={() => handleViewDetails(job.id)}
                />
              </div>
            ))}
          </Grid>
        ) : (
          <p>No jobs with IN-PROGRESS status found.</p>
        )}
      </Grid>
    </>
  );
}


export default CreatedJobs;
